import { useTranslation } from 'react-i18next'

import { UserStatus } from '../../../../../types/user/userProfile'
import { userStatusI18nKey } from '../../../../../utils/users/user'

type UserStatusBadgeProps = {
  status?: UserStatus
  locked?: boolean
}

const statusBadgeClass: Record<UserStatus, string> = {
  [UserStatus.REGISTERED]: 'badge badge-success',
  [UserStatus.MANAGED]: 'badge badge-info',
  [UserStatus.PENDING_CONFIRMATION]: 'badge badge-warning',
}

const statusLabelKey = ({ status, locked }: UserStatusBadgeProps) => {
  if (locked) {
    return 'users.status.locked'
  }

  return status ? userStatusI18nKey(status) : 'users.list.unavailable'
}

const statusClass = ({ status, locked }: UserStatusBadgeProps) => {
  if (locked) {
    return 'badge badge-danger'
  }

  return (status && statusBadgeClass[status]) ?? 'badge'
}

export const UserStatusBadge = (props: UserStatusBadgeProps) => {
  const { t } = useTranslation('users')

  return <span className={statusClass(props)}>{t(statusLabelKey(props))}</span>
}

export const UserStatusText = (props: UserStatusBadgeProps) => {
  const { t } = useTranslation('users')

  return <span>{t(statusLabelKey(props))}</span>
}
